import { createAsyncThunk } from '@reduxjs/toolkit';

import { TaxStatementService } from 'api';

import { StatementProps } from 'models/api';

import { asyncPayloadCreator } from 'utils';

export const generateTaxStatement = createAsyncThunk(
	'statement/generateTaxStatement',
	(credentials: StatementProps, { rejectWithValue }) =>
		asyncPayloadCreator(credentials, { rejectWithValue }, TaxStatementService.generate),
);
